const InvestmentChallenge1HintsText =
    ["There are 5 items in the 'Statements are False' column " +
        "that should be moved to the 'Statements are True' column.",
     "Probably not a good idea to buy an investment when the price " +
        " goes up.  Trying to 'time the market' is not usually a good plan.",
     "Being diversified in the market means owning different kinds of investments. ",
     "Planning on withdrawing money from a 401(k) account before you reach " +
        "the age of 59 and 1/2 is not a good idea."
    ]

export default InvestmentChallenge1HintsText;